export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const getStatusBadgeClass = (status) => {
  const statusLower = status?.toLowerCase() || '';

  if (statusLower === 'running' || statusLower === 'ready' || statusLower === 'available') {
    return 'badge-success';
  }
  if (statusLower === 'pending' || statusLower === 'creating' || statusLower === 'cache-building') {
    return 'badge-warning';
  }
  if (statusLower === 'failed' || statusLower === 'error') {
    return 'badge-danger';
  }
  return 'badge-info';
};

export const formatRelativeTime = (timestamp) => {
  if (!timestamp) return 'never';
  const date = timestamp._seconds
    ? new Date(timestamp._seconds * 1000)
    : new Date(timestamp);
  if (isNaN(date.getTime())) return 'unknown';
  const diffMs = Date.now() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  if (diffMins < 1) return 'just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) return `${diffHours}h ago`;
  return `${Math.floor(diffHours / 24)}d ago`;
};
